<template>
  <b-form
      data-vv-scope="worker-information-form"
      @submit.prevent="onSubmit"
  >
    <div class="row">
      <div class="col-lg-4 col-md-12">
        <b-form-group>
          <ListGroups
              name="UNIDAD_DESEMPENO_ID"
              data-cy="performance-unit"
              autocomplete
              label="Unidad de desempeño"
              :typeList="stepType"
              v-model="form.UNIDAD_DESEMPENO_ID"
              @input="agregarUnidad"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-md-12">
        <b-form-group>
          <ListUser
              name="jefatura_responsable"
              label="Jefatura responsable"
              data-cy="responsible-leadership"
              autocomplete
              placeholder="Seleccione un usuario"
              v-model="form.JEFATURA_ID"
              @input="agregarJefatura"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-md-12">
        <b-form-group
        label="Cargo jefatura"
        data-cy="leadership-position"
        >
          <b-form-input
              maxlength="99"
              v-model="form.JEFATURA_CARGO"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-sm-12">
        <b-form-group
        label="Tipo de jornada"
        data-cy="type-of-day"
        >
          <b-form-input
              maxlength="99"
              v-model="form.JORNADA"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-sm-12">
        <b-form-group
        label="Cargo"
        data-cy="company-position"
        >
          <b-form-input
              maxlength="99"
              v-model="form.CARGO"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-md-12">
        <b-form-group
          label="Grado"
          data-cy="grade-position"
        >
          <b-form-input
            maxlength="99"
            v-model="form.GRADO"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-sm-12">
        <b-form-group
        label="Departamento"
        data-cy="department"
        >
          <b-form-input
              maxlength="99"
              v-model="form.DEPARTAMENTO"
          />
        </b-form-group>
      </div>
      <div class="col-lg-4 col-sm-12">
        <b-form-group
        label="Rol"
        data-cy="role"
        >
          <b-form-input
              maxlength="150"
              v-model="form.ROL"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-form-group
        label="Funciones del cargo"
        data-cy="functions"
        >
          <b-form-tags
              remove-on-delete
              placeholder="Escriba la funcion y presione enter"
              v-model="form.FUNCIONES"
              addButtonText="Agregar"
          />
        </b-form-group>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-center">
        <vs-button
            class="mt-3 mb-5"
            data-cy="save"
            @click="onSubmit()"
            color="primary"
            type="border"
        >
          GUARDAR CAMBIOS <span
            v-show="loading"
            class="spinner-border spinner-border-sm text-white ml-1 mb-1"
        />
        </vs-button>
      </div>
    </div>
  </b-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import ListUser from '@/febos/chile/lists/components/ListUser';
import ListGroups from '@/febos/chile/lists/components/ListGroups';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';
import { getUserById } from '@/febos/servicios/api/usuarios.api';

export default {
  name: 'WorkerInformation',
  components: { ListUser, ListGroups },
  props: ['user'],
  data() {
    return {
      stepType: StepTypes.GROUP,
      loading: false,
      form: {
        UNIDAD_DESEMPENO_ID: null,
        JEFATURA_ID: null,
        JEFATURA_CARGO: null,
        JORNADA: null,
        CARGO: null,
        DEPARTAMENTO: null,
        GRADO: null,
        ROL: null,
        FUNCIONES: [],
        FUNCIONESN: 0
      }
    };
  },
  async created() {
    await this.getWorkerData({
      tipoRespuesta: 2, // Hay 1 y 2
      elementoId: this.user.id,
      referenciaId: this.company.id,
      filtros: `nombre:${Object.keys(this.form).join()}`
    });
    if (Object.keys(this.workerData).length !== 0) {
      this.form.UNIDAD_DESEMPENO_ID = this.workerData.UNIDAD_DESEMPENO_ID?.valor;
      this.form.JEFATURA_ID = this.workerData.JEFATURA_ID?.valor;
      this.form.JEFATURA_CARGO = this.workerData.JEFATURA_CARGO?.valor;
      this.form.JORNADA = this.workerData.JORNADA?.valor;
      this.form.CARGO = this.workerData.CARGO?.valor;
      this.form.GRADO = this.workerData.GRADO?.valor;
      this.form.DEPARTAMENTO = this.workerData.DEPARTAMENTO?.valor;
      this.form.ROL = this.workerData.ROL?.valor;
      if (Object.prototype.hasOwnProperty.call(this.workerData, 'FUNCIONES')) {
        const funciones = this.workerData.FUNCIONES;
        Object.keys(funciones).forEach(
          (fnc) => this.form.FUNCIONES.push(funciones[fnc]?.valor)
        );
      }
      await this.hydrateJefaturaOption(this.form.JEFATURA_ID);
    }
  },
  methods: {
    ...mapActions('Management', [
      'getWorkerData',
      'setWorkerData'
    ]),
    ...mapActions('Usuario', [
      'updateProfile',
      'setLocalWorkerData'
    ]),
    agregarUnidad(id) {
      this.form.UNIDAD_DESEMPENO_ID = id;
    },
    agregarJefatura(id) {
      this.form.JEFATURA_ID = id;
    },
    /**
     * Hidrata SOLO la opción inicial del ListUser de "Jefatura responsable"
     * resolviendo el usuario por su ID. Siembra la opción en el índice de la
     * lista de usuarios (indexedBy = companyId, que es el que usa este ListUser
     * al no aplicar filtros) para que optionSelected la encuentre y la muestre.
     * No persiste nada nuevo: JEFATURA_ID sigue siendo el único dato guardado.
     */
    async hydrateJefaturaOption(jefaturaId) {
      if (!jefaturaId) {
        return;
      }
      try {
        const resp = await getUserById(jefaturaId);
        const usuario = resp?.data?.usuario;
        if (usuario) {
          this.$store.commit('List/SET_LIST_INDEXED', {
            target: 'users',
            indexedBy: this.company.id,
            value: [usuario],
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async onSubmit() {
      if (this.loading) {
        return;
      }
      const data = [];
      this.form.FUNCIONESN = this.form.FUNCIONES.length;
      Object.entries(this.form).forEach((f) => {
        const nombre = f[0];
        const valor = f[1];
        const value = valor !== null && valor !== undefined && valor !== '';
        if (value && !Array.isArray(valor)) {
          const obj = {
            nombre,
            valor,
            referenciaId: this.company.id
          };
          data.push(obj);
        }
        if (Array.isArray(valor)) {
          /* Recorro el arreglo de funciones del usuario */
          valor.forEach((v, index) => {
            const obj = {
              nombre: `FUNCIONESN-${index}`,
              valor: v,
              referenciaId: this.company.id
            };
            data.push(obj);
          });
        }
      });
      if (data.length > 0) {
        const body = {
          elementoId: this.user.id,
          extraData: data
        };
        this.loading = true;
        let resp = null;
        try {
          resp = await this.setWorkerData(body);
        } catch (error) {
          console.log(error);
        }

        if (resp && resp.data.codigo === 10) {
          this.$bvToast.toast(
            'La información ha sido modificado correctamente',
            {
              title: 'Guardar',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 15000
            }
          );
          if (this.user.id === this.currentUser.id) {
            const updatedUser = { ...this.currentUser };
            updatedUser.cargo = this.form.CARGO;
            updatedUser.grado = this.form.GRADO;
            updatedUser.departamento = this.form.DEPARTAMENTO;
            await this.setLocalWorkerData(updatedUser);
          }
        } else {
          this.loading = false;
          this.$bvToast.toast(
            'Parece que hubo un error, reitenta porfavor',
            {
              title: 'Guardar',
              variant: 'danger',
              pauseOnHover: true,
              solid: true,
              autoHideDelay: 15000
            }
          );
        }
      }
      this.loading = false;
      this.$emit('close-action');
    }
  },
  computed: {
    ...mapGetters('Management', [
      'workerData'
    ]),
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  }
};
</script>

<style scoped>

</style>
